import ScreenKey from '@/Enums/Screens/ScreenKey.enum';
import { SCREEN_ROUTES, SIDEBAR_SCREEN_LABELS } from '@/constants/routes';
import { Chip } from '@mui/material';
import SidebarLink from './SidebarLink';
import SidebarRouteIcon from './SidebarRouteIcon';

// Toggled at deploy time, not in code, per #4468 — set it to 'false' once
// Unified Reporting exits beta, rather than removing this component.
const UNIFIED_REPORTING_BETA = import.meta.env.VITE_UNIFIED_REPORTING_BETA !== 'false';

const ScreenLinks = ({ screens, sidebarOpen }) =>
  screens.map(screen => (
    <SidebarLink key={screen.name} sidebarOpen={sidebarOpen} to={SCREEN_ROUTES[screen.name]}>
      <SidebarRouteIcon screen={screen.name} />
      {/* Truncates instead of the Chip below it getting clipped by the
          sidebar's fixed width + overflowX: hidden — "Custom Dashboards" is
          long enough on its own to push a trailing Beta chip past the edge. */}
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {SIDEBAR_SCREEN_LABELS[screen.name]}
      </span>
      {(screen.name === ScreenKey.REPORTING_V2 || screen.name === ScreenKey.CUSTOM_DASHBOARDS) &&
        UNIFIED_REPORTING_BETA && (
          // Explicit, opaque colors rather than MUI's default Chip palette: the
          // sidebar's background is whitelabel-themeable (every org picks its own
          // dark color), and the default grey-on-transparent chip read as almost
          // invisible against several of those skins — only readable once a row's
          // own selected-state background lightened underneath it.
          <Chip
            label='Beta'
            size='small'
            sx={{
              ml: 0.75,
              height: 18,
              fontSize: '0.65rem',
              fontWeight: 700,
              bgcolor: '#fff',
              color: '#171725',
              flexShrink: 0,
            }}
          />
        )}
    </SidebarLink>
  ));

export default ScreenLinks;
